/* Chấm chỉ báo cho các dải trượt ngang trên điện thoại.
 *
 * User đã chốt: bỏ thanh cuộn ngang trên toàn site, thay bằng chấm/gạch như
 * BrickWar. Dải trượt hiện ẩn thanh cuộn (scrollbar-width:none) nên nếu không
 * có chấm thì khách KHÔNG biết còn thẻ phía sau — thẻ thứ hai ló ra là tín hiệu
 * duy nhất, quá yếu.
 *
 * Chấm dựng bằng JS vì số thẻ do Liquid sinh ra (3 xe lấy từ collection), không
 * cố định trong markup.
 */
(function () {
  'use strict';

  // `.vids` (cụm video) dùng chung cơ chế với các dải kia: cùng bộ luật CSS
  // slider ở khối 749px, nên cũng nhận chấm từ đây thay vì tự dựng riêng.
  var TRACKS = '.lb-demo .g3--cards, .lb-demo .cmp, .lb-demo .sec--dark .g3:not(.cmp),'
             + ' .lb-demo .vids';
  var MOBILE = '(max-width: 749px)';
  var THUMBS = '.lb-demo .thumbs';

  // Dải reviews KHÔNG do file này lo nữa — nó chạy bằng Splide trong
  // legendbrix-reviews-slider.js. Vòng lặp tự chế ở đây (nhân ba bộ thẻ rồi
  // dịch `scrollLeft`) đã gỡ hẳn cùng hàm kéo chuột đi kèm: cả hai chỉ phục vụ
  // `.rvsl`, và cơ chế đó vá bảy lần vẫn giật vì ghi `scrollLeft` giữa lúc
  // trình duyệt còn chạy đà. Lý do đầy đủ nằm ở đầu file kia.
  //
  // Còn lại ở đây: chấm cho các lưới chỉ trượt trên điện thoại (TRACKS) và
  // mũi tên cho dải thumbnail (THUMBS).

  // Tự chạy hoạt ảnh thay vì behavior:'smooth'.
  //
  // Đo được trên máy: gán scrollLeft và scrollBy({behavior:'auto'}) đều chạy,
  // riêng scrollBy({behavior:'smooth'}) bị huỷ và dải bật về 0 — `scroll-snap-type:
  // x mandatory` giành quyền điều khiển cuộn với hoạt ảnh mượt của trình duyệt.
  // Gán thẳng scrollLeft thì snap chỉ can thiệp lúc kết thúc, đúng như mong muốn.
  //
  // Dùng chung cho chấm và mũi tên. Handle rAF gắn lên chính phần tử để hai dải
  // khác nhau không huỷ hoạt ảnh của nhau.
  function truotToi(track, dich, xong) {
    if (track.__lbRaf) cancelAnimationFrame(track.__lbRaf);
    var dau = track.scrollLeft;
    var quang = dich - dau;
    if (Math.abs(quang) < 1) { if (xong) xong(); return; }
    // Tab ẩn thì requestAnimationFrame ngừng chạy và dải sẽ đứng im giữa chừng.
    // Nhảy thẳng tới đích trong trường hợp đó.
    if (document.hidden) { track.scrollLeft = dich; if (xong) xong(); return; }
    var t0 = performance.now();
    var THOI_GIAN = 320;
    (function buoc(now) {
      var t = Math.min((now - t0) / THOI_GIAN, 1);
      var e = 1 - Math.pow(1 - t, 3);          // ease-out
      track.scrollLeft = dau + quang * e;
      if (t < 1) { track.__lbRaf = requestAnimationFrame(buoc); }
      else { track.__lbRaf = null; if (xong) xong(); }
    })(t0);
  }

  // ── Mũi tên cho dải thumbnail của trang sản phẩm ──────────────────────────
  // Dựng bằng JS chứ không bằng Liquid: hai nút chỉ có nghĩa trên điện thoại và
  // chỉ khi có nhiều hơn một khung ảnh. In sẵn trong Liquid thì bản máy tính
  // cũng mang theo hai node thừa ở mọi trang sản phẩm.
  //
  // Icon vẽ bằng SVG, KHÔNG dùng ký tự ‹ ›: bộ chữ của theme không có glyph cho
  // chúng và trình duyệt vẽ ra ô vuông rỗng.
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ' +
                'aria-hidden="true"><polyline points="%s"/></svg>';

  function dungMuiTen(track) {
    if (track.dataset.lbNav === 'on') return;
    // Bốn ô vừa một khung: ít hơn năm ảnh thì không có gì để trượt.
    if (track.children.length < 5) return;
    track.dataset.lbNav = 'on';
    track.classList.add('thumbs--nav');

    var hang = document.createElement('div');
    hang.className = 'thumbnav';
    track.parentNode.insertBefore(hang, track);

    function nut(huong, diem, nhan) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'thumbnav__b';
      b.setAttribute('aria-label', nhan);
      b.innerHTML = CHEVRON.replace('%s', diem);
      b.addEventListener('click', function () {
        // Trượt trọn một khung, không phải một ảnh: khách bấm mũi tên là muốn
        // sang nhóm ảnh kế tiếp.
        var dich = track.scrollLeft + huong * track.clientWidth;
        truotToi(track, dich);
        // Cập nhật NGAY theo vị trí đích, không đợi sự kiện cuộn. Cùng lý do đã
        // ghi ở phần chấm: người bấm cần phản hồi tức thì. Ở đây còn một lý do
        // nữa — đo được là dải này không phát sự kiện `scroll` khi gán
        // scrollLeft bằng mã, nên chỉ dựa vào listener thì hai nút không bao giờ
        // đổi trạng thái.
        capNhat(dich);
      });
      return b;
    }

    var trai = nut(-1, '15 18 9 12 15 6', 'Previous images');
    var phai = nut(1, '9 18 15 12 9 6', 'Next images');
    hang.appendChild(trai);
    hang.appendChild(track);
    hang.appendChild(phai);

    // Mờ nút khi đã hết đường. Ngưỡng 2px vì scrollLeft là số thực và hiếm khi
    // chạm đúng biên. `duDoan` là vị trí đích khi vừa bấm nút — lúc đó dải chưa
    // trượt tới nơi, đọc scrollLeft sẽ ra trạng thái của khung CŨ.
    function capNhat(duDoan) {
      var het = track.scrollWidth - track.clientWidth;
      var x = duDoan === undefined ? track.scrollLeft : Math.max(0, Math.min(duDoan, het));
      trai.setAttribute('aria-disabled', x <= 2 ? 'true' : 'false');
      phai.setAttribute('aria-disabled', x >= het - 2 ? 'true' : 'false');
    }
    track.addEventListener('scroll', capNhat, { passive: true });
    capNhat();
  }

  function build(track) {
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2 || track.dataset.lbDots === 'on') return;
    track.dataset.lbDots = 'on';

    // Khoảng cách từ mép trái dải trượt tới mép trái thẻ, tính theo toạ độ
    // thực. KHÔNG dùng offsetLeft: nó tính theo offsetParent, mà dải trượt
    // không có `position` nên offsetParent là một tổ tiên khác — mọi phép tính
    // lệch đi và bấm chấm không trượt đi đâu cả.
    function lech(slide) {
      return slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
    }
    function dem() {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }

    // Sắp theo thứ tự NHÌN THẤY, không theo thứ tự DOM. Khối so sánh dùng CSS
    // `order` để đưa thẻ LEGENDBRIX lên đầu trên điện thoại; nếu dựng chấm theo
    // DOM thì chấm thứ hai sáng trong khi khách đang xem thẻ đầu tiên.
    slides.sort(function (a, b) { return lech(a) - lech(b); });

    var dots = document.createElement('div');
    dots.className = 'lb-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Slides');

    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' / ' + slides.length);
      b.addEventListener('click', function () {
        // Trừ đệm trái để thẻ dừng đúng lề 24px, không dính mép màn hình.
        truotToi(track, track.scrollLeft + lech(slide) - dem());
        // Đánh dấu NGAY, không đợi sự kiện cuộn: người bấm cần phản hồi
        // tức thì, mà sự kiện cuộn là bất đồng bộ nên chấm sẽ trễ một nhịp.
        danhDau(i);
      });
      dots.appendChild(b);
    });
    track.insertAdjacentElement('afterend', dots);


    // Gọi thẳng, KHÔNG gom qua requestAnimationFrame: rAF bị treo khi tab ẩn
    // hoặc ở nền, nên chấm đứng im dù dải đã trượt. Mỗi dải chỉ 3 thẻ, phép
    // tính không đáng kể.
    function danhDau(chon) {
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.setAttribute('aria-selected', i === chon ? 'true' : 'false');
      });
    }

    // Thẻ nằm sát lề trái vùng nhìn. Mũi tên dùng phép này để bước MỘT thẻ.
    function chiSoTrai() {
      var best = 0, min = Infinity, pad = dem();
      slides.forEach(function (s, i) {
        var d = Math.abs(lech(s) - pad);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }

    function sync() {
      // Cuộn hết đường: thẻ CUỐI đang hiện trọn vẹn dù mép trái của nó không
      // trùng lề trái. Không xét riêng thì phép "thẻ gần lề trái nhất" chọn
      // nhầm thẻ áp chót ở mọi dải có thẻ rộng hơn nửa màn hình.
      //
      // Chỉ áp cho CHẤM, không áp cho mũi tên: chấm nói "bạn đang xem tới thẻ
      // cuối", còn mũi tên cần biết thẻ nào đang ở lề trái để bước tiếp.
      var het = track.scrollWidth - track.clientWidth;
      if (het > 0 && track.scrollLeft >= het - 2) { danhDau(slides.length - 1); return; }
      danhDau(chiSoTrai());
    }
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  }


  function init() {
    if (!window.matchMedia(MOBILE).matches) return;
    document.querySelectorAll(TRACKS).forEach(build);
    document.querySelectorAll(THUMBS).forEach(dungMuiTen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Xoay ngang/dọc hoặc đổi cỡ cửa sổ: dựng chấm nếu lúc tải là màn rộng.
  window.matchMedia(MOBILE).addEventListener('change', init);
})();
